import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-datepicker', 'selectDate', 'Select date');
Labels.set('ui-datepicker', 'selectedDate', 'Selected date');
Labels.set('ui-datepicker', 'close', 'Close');
Labels.set('ui-datepicker', 'clear', 'Clear input');
Labels.set(
    'ui-datepicker',
    'invalidFormatHint',
    'Use the dd.mm.yyyy format, like 24.12.2026'
);
Labels.set(
    'ui-datepicker',
    'invalidFormatHintLt',
    'Use the yyyy-mm-dd format, like 2026-12-24'
);
